export const IFRAME_ID_PARAM = 'iframeId';
export const IFRAME_RETRY_PARAM = 'retry';

/**
 * `retryCount` is a cache-buster: a retry has to change the `src` for the browser to
 * re-fetch a remote that never came up, and resetting the store alone would not.
 * Omitted at 0 so the happy-path URL stays clean.
 */
export function appendIframeId(url: string, iframeId: string, retryCount = 0): string {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set(IFRAME_ID_PARAM, iframeId);
  if (retryCount > 0) {
    urlObj.searchParams.set(IFRAME_RETRY_PARAM, String(retryCount));
  }
  return urlObj.toString();
}

export function extractIframeId(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(IFRAME_ID_PARAM);
}
